import { loadStripe } from "@stripe/stripe-js/pure";
import type { Stripe } from "@stripe/stripe-js";

/**
 * Stripe.js 初始化。
 *
 * 用 @stripe/stripe-js/pure（无 side-effect：不配置 key 时不会加载 Stripe.js）。
 * 注意：本项目是 CRA(craco)，环境变量用 REACT_APP_ 前缀 + process.env，
 * 而非文档里的 Vite 写法（import.meta.env.VITE_*）。
 *
 * 在 .env.local 配置：
 *   REACT_APP_STRIPE_PUBLISHABLE_KEY=pk_test_xxxxx
 */
// 默认写死一个 test 公钥（pk_ 是公开的，可安全内联）；
// 生产构建时用 env 覆盖为 pk_live_...（无需改代码）。
const PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  "pk_test_51U3LaP6LRvINxVNWTwYlddgPXwqYympEMBkmGc0YnTdurPrioYHq1GhyQK0DPH3R3NvnDgqma7J4ZpsDsyOgNxl3009PG0t1Ni";

/** 是否已配置 Stripe（未配置时支付相关功能不可用，但页面正常） */
export const isStripeConfigured = !!PUBLISHABLE_KEY;

let stripePromise: Promise<Stripe | null> | null = null;

/** 惰性获取 Stripe 实例；未配置 key 时返回 null */
export function getStripe(): Promise<Stripe | null> | null {
  if (!PUBLISHABLE_KEY) return null;
  if (!stripePromise) stripePromise = loadStripe(PUBLISHABLE_KEY);
  return stripePromise;
}
